document.addEventListener('DOMContentLoaded', function() {
    const tracks = document.querySelectorAll('.carousel-track');

    tracks.forEach(track => {
        const items = Array.from(track.children);
        const container = track.parentElement; // overflow-hidden wrapper

        let itemsPerView = 1;
        let slideCount = 1;
        let currentSlide = 0;

    	const carouselRoot = track.closest('.relative');
		const prevButton = carouselRoot.querySelector('.carousel-prev');
        const nextButton = carouselRoot.querySelector('.carousel-next');
    	const dotsContainer = carouselRoot.querySelector('.carousel-dots');

        function updateLayout() {
            // determine items per view based on breakpoints
            if (window.innerWidth >= 1024) {
                itemsPerView = 3;
            } else if (window.innerWidth >= 480) {
                itemsPerView = 2;
            } else {
                itemsPerView = 1;
            }

            slideCount = Math.max(1, Math.ceil(items.length / itemsPerView));

            // set each item's width so itemsPerView fill the container
            const pct = 100 / itemsPerView;
            items.forEach(item => {
                item.style.flex = `0 0 ${pct}%`;
                item.style.maxWidth = `${pct}%`;
            });

            // ensure currentSlide is in bounds
            if (currentSlide > slideCount - 1) currentSlide = slideCount - 1;

            // (re)build dots
            if (dotsContainer) {
                dotsContainer.innerHTML = '';
                for (let i = 0; i < slideCount; i++) {
                    const b = document.createElement('button');
                    b.type = 'button';
                    b.className = 'carousel-dot button-reset';
                    b.setAttribute('aria-label', `Go to slide ${i + 1}`);
                    b.setAttribute('role', 'tab');
                    b.dataset.index = i;
                    if (i === currentSlide) {
                        b.classList.add('active');
                        b.setAttribute('aria-selected', 'true');
                    } else {
                        b.setAttribute('aria-selected', 'false');
                    }
                    b.addEventListener('click', (e) => {
                        currentSlide = Number(e.currentTarget.dataset.index);
                        updateTrackPosition();
                    });
                    dotsContainer.appendChild(b);
                }
            }

            updateTrackPosition();
        }

        function updateTrackPosition() {
            const slideWidth = container.clientWidth;
            track.style.transform = `translateX(-${currentSlide * slideWidth}px)`;

            // update button states
            const prevDisabled = currentSlide === 0;
            const nextDisabled = currentSlide >= slideCount - 1;
            prevButton.disabled = prevDisabled;
            nextButton.disabled = nextDisabled;
            prevButton.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
            nextButton.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');

            // update dots selection
            if (dotsContainer) {
                Array.from(dotsContainer.children).forEach((dot, idx) => {
                    const selected = idx === currentSlide;
                    dot.setAttribute('aria-selected', selected ? 'true' : 'false');
                    if (selected) {
                        dot.classList.add('active');
                    } else {
                        dot.classList.remove('active');
                    }
                });
            }
        }

        prevButton.addEventListener('click', () => {
            if (currentSlide > 0) {
                currentSlide--;
                updateTrackPosition();
            }
        });

        nextButton.addEventListener('click', () => {
            if (currentSlide < slideCount - 1) {
                currentSlide++;
                updateTrackPosition();
            }
        });

        // reset and recalculate on resize
        window.addEventListener('resize', () => {
            // keep same slide if possible, otherwise clamp
            updateLayout();
        });

        // keyboard navigation: left/right arrows when the carousel root is focused
        if (carouselRoot) {
            carouselRoot.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowRight') {
                    if (currentSlide < slideCount - 1) {
                        currentSlide++;
                        updateTrackPosition();
                    }
                    e.preventDefault();
                } else if (e.key === 'ArrowLeft') {
                    if (currentSlide > 0) {
                        currentSlide--;
                        updateTrackPosition();
                    }
                    e.preventDefault();
                }
            });
        }

        // initialize
        updateLayout();
    });
});
